import i18n from 'i18next'
import type { TOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'

import { getCookieConsent } from 'components/cookie-consent/consent-storage'

import { Locale } from '../utils/LanguageUtils'

import de from './locales/de.json'
import en from './locales/en.json'

declare module 'i18next' {
  interface TFunction {
    (key: string | string[], options?: TOptions | string): string
  }
}

const LANGUAGE = 'language'

const initialLanguage = localStorage.getItem(LANGUAGE) || 'de'

export const changeLanguage = (language: Locale) => {
  i18n.changeLanguage(language)
  const cookie = getCookieConsent()

  // only save language if allowed by cookie consent
  if (cookie.preferences) {
    localStorage.setItem(LANGUAGE, language as string)
  }
}

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translations: en
    },
    de: {
      translations: de
    }
  },
  ns: ['translations'],
  defaultNS: 'translations',
  fallbackLng: 'de',
  lng: initialLanguage,
  nsSeparator: '::',
  interpolation: {
    escapeValue: false // react already uses text nodes, not innerHtml - usually safe from xss => https://www.i18next.com/translation-function/interpolation#unescape
  }
})

i18n.languages = ['en', 'de']

// update <html lang="en"> attribute
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng
})

export { LANGUAGE, i18n }
